module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Dinesh Alapati","short_name":"Dinesh","start_url":"/","background_color":"#303030","theme_color":"#303030","display":"minimal-ui","icon":"src/assets/images/icons-rocket-100.png"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
